/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumDokument: {
    name: 'big-medium-dokument';
    data: string;
} = {
    name: 'big-medium-dokument',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M108.9 37.39c0-.14-.08-.27-.12-.41a5 5 0 0 0-.16-.52 4 4 0 0 0-.25-.47c-.07-.13-.13-.27-.21-.39a4.6 4.6 0 0 0-.63-.76L77.12 4.46h-.05a4.5 4.5 0 0 0-.72-.59 3 3 0 0 0-.37-.2 5 5 0 0 0-.49-.26 4 4 0 0 0-.5-.15 3 3 0 0 0-.43-.13 6 6 0 0 0-.93-.1H28a9 9 0 0 0-9 9V116a9 9 0 0 0 9 9h72a9 9 0 0 0 9-9V38.37a4.6 4.6 0 0 0-.1-.98M78.58 20.06l13.34 13.31H78.58zM99 115H29V13h39.58v21.37a9 9 0 0 0 9 9H99z"/></svg>`,
};
